require('lib/browser_required')('lib/jquery_ajax_filter')

const g = require('globals')
const $ = require('jquery')
const _ = require('lib/underscore')
const config = require('lib/config')
const log = require('log').create('ajax', 'prefilter')  

// prefilter to simplify our JSON api calls
// this isn't working correctly for some reason..
function prepJsonXhr(options, originalOptions, jqXHR) {
    // don't apply to $.fileupload requests
    if (options.fileInput) return

    // set json header
    jqXHR.setRequestHeader('Content-Type', 'application/json')
}

// factory for json error parser to ensure that json fail handlers receive a
// JSON error object
function makeJsonErrorParser(handler) {
    return function jsonErrorParser(xhr, statusText, errorThrown) {
        let json = xhr.responseJSON
        if (! json) {
            try {
                json = JSON.parse(xhr.responseText)
            } catch {
                json = {}
            }
        }
        json.type = json.type || 'unspecified'
        json.status = json.status || xhr.status
        handler(json, xhr, statusText, errorThrown)
    }
}

// wrap ajax fail to always return the JSON response to the fail handler
function applyJsonErrorParser(options, originalOptions, jqXHR) {
    // don't modify fail handler for $.fileupload requests
    if (options.fileInput) return

    jqXHR.fail = _.wrap(jqXHR.fail, (originalFail, originalHandler) => {
        // fail silently if no handler is provided
        if (originalHandler) {
            const jsonErrorParser = makeJsonErrorParser(originalHandler)
            originalFail(jsonErrorParser)
        }
        return jqXHR
    })
}

// add X-Auth-Token header to all local ajax requests
// headers: { 'X-Auth-Token': g.AUTH_TOKEN },
function applyAuthTokenHeader(options, originalOptions, jqXHR) {
    const isApi = options.url.startsWith(g.NODE_API)
    const isImageProcessor = options.url.startsWith(config.get('image_processor_url'))

    if (isApi || isImageProcessor) {
        log('match', options.url)

        jqXHR.setRequestHeader('X-Auth-Token', g.AUTH_TOKEN)

        if (!options.xhrFields) options.xhrFields = {}
        options.xhrFields.withCredentials = true
    }
}

// remove Content-Disposition header from file uploads
function removeContentDisposition(options, originalOptions, jqXHR) {
    if (options.headers) delete options.headers['Content-Disposition']
}

function initialize() {
    // $.ajaxPrefilter('json', prepJsonXhr)
    $.ajaxPrefilter('json', applyJsonErrorParser)
    $.ajaxPrefilter(applyAuthTokenHeader)
    $.ajaxPrefilter(removeContentDisposition)
}

module.exports = {
    initialize,
    prepJsonXhr,
    makeJsonErrorParser,
    applyJsonErrorParser,
    applyAuthTokenHeader,
}
